import viewSpec from "./viewSpec";

export default function hasDefaultItem(menuItem) {
	return viewSpec.isXSmallScreen() ? false : (menuItem.url);
}
